import React from "react";
import classnames from "classnames";
import { map } from "lodash";

import "./StepInfo.scss";

interface StepProps {
  isActive?: boolean;
  label?: string;
  index?: number;
}

const Step = ({ isActive, label, index }: StepProps) => {
  return (
    <div
      className={classnames("step", {
        ["is-active"]: isActive,
      })}
    >
      <span className="step-line" />
      <p className="step-label">
        {index}. {label}
      </p>
    </div>
  );
};

interface StepItem {
  index: number;
  label?: string;
}

interface StepInfoProps {
  activeStepNumber?: number | string;
  steps?: StepItem[];
}

const StepInfo = ({ activeStepNumber, steps }: StepInfoProps) => {
  return (
    <div className="step-wrapper">
      {map(steps, (step, idx) => {
        return (
          <Step
            isActive={(activeStepNumber as number) >= step.index}
            key={step.index}
            label={step.label}
            index={idx + 1}
          />
        );
      })}
    </div>
  );
};

export default StepInfo;
